<template>
  <div class="tabs">
    <div
      v-for="(item, index) in list"
      :key="index"
      :style="!scrollable ? `width: calc(100% / ${list.length})` : ''"
      :class="
        (item.id || index) === (tabValue === null ? activited : tabValue)
          ? 'selected'
          : 'unselected'
      "
      @click="tabClick(item, item.id || index)"
    >
      {{ item.name }}
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  model: {
    prop: "tabValue",
    event: "onChange"
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    tabValue: {
      type: String,
      default: null
    },
    scrollable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activited: 0
    };
  },
  methods: {
    tabClick(item, index) {
      this.activited = index;
      this.$emit("onChange", index);
      this.$emit("tabClick", item, index);
    }
  }
};
</script>

<style lang="less" scoped>
.tabs {
  display: flex;
  width: 100%;
  height: 2.63rem;
  overflow-x: scroll;
  white-space: nowrap;
  background-color: #fff;
  border-bottom: 1px solid #efeff4;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.tabs::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.selected {
  padding: 10px;
  color: #108eee;
  font-size: 0.94rem;
  text-align: center;
  border-bottom: 3px solid #108eee;
}
.unselected {
  padding: 10px;
  color: #2c3e50;
  font-size: 0.94rem;
  text-align: center;
}
</style>
